import { ds } from "js/core/models/dataService";
import { $, _, Backbone } from "js/vendor";
import { app } from "js/namespaces";
import { controls } from "js/editor/ui";
import ErrorHandler from "js/core/utilities/errorHandler";
import { checkSlideCount } from "js/core/models/presentation";
import { ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import { SlideTemplateInfoPage } from "js/react/views/SlideTemplateInfo/slideTemplateInfoPage";
import { AddSlideController } from "js/react/views/AddSlide/AddSlideController";
import { getSlideMenu } from "js/editor/editorMenu";
import { SlideLockType } from "common/constants";
import { AddSlideContainer } from "js/react/views/AddSlide";

const SlideOptions = Backbone.View.extend({
    className: "slide_options",

    events: {
        "click .template-info": "showTemplateInfo",
        "click .add_slide": "addSlide",
        "click .duplicate_slide": "duplicateSlide",
        "click .more_options": "toggleMoreOptions",
    },

    update: function() {
        this.render();
    },

    render: function() {
        this.$el.empty();

        this.$el.append($.div("spacer"));

        let $addSlide = $.div("add_slide button");
        $addSlide.append($.icon("add_circle"));
        $addSlide.append($.label("Add Slide"));
        this.$el.append($addSlide);

        let $dupeSlide = $.div("duplicate_slide button");
        $dupeSlide.append($.icon("content_copy"));
        $dupeSlide.append($.label("Duplicate"));
        this.$el.append($dupeSlide);

        this.$moreOptions = $.div("more_options button");
        this.$moreOptions.append($.icon("more_horiz"));
        this.$moreOptions.append($.label("More"));
        this.$el.append(this.$moreOptions);

        let deleteAction;
        if (!ds.selection.slide || !ds.selection.slide.get("libraryItemId")) {
            deleteAction = "Delete";
        } else {
            deleteAction = "Remove";
        }

        let $delete = this.$el.addEl(controls.createHoldButton(this, {
            icon: "delete",
            label: deleteAction,
            holdLabel: `Hold to ${deleteAction}`,
            callback: () => {
                this.deleteSlide();
            }
        })).addClass("delete_slide");

        this.listenTo(app.mainView.editorView.lockModel, "change:lockState", model => {
            if (model.attributes.lockState[SlideLockType.COLLABORATION]) {
                $delete.addClass("disabled");
                this.$moreOptions.addClass("disabled");
                return;
            } else {
                $delete.removeClass("disabled");
                this.$moreOptions.removeClass("disabled");
            }

            if (
                (model.attributes.lockState[SlideLockType.ORG] || model.attributes.lockState[SlideLockType.TEAM_MEMBER]) &&
                (!app.user.has("teams") || !ds.selection.slide.isLibrarySlideInCurrentUserOrg())
            ) {
                $delete.addClass("disabled");
            } else {
                $delete.removeClass("disabled");
            }
        });

        return this;
    },

    showTemplateInfo: function() {
        ShowDialog(SlideTemplateInfoPage, {
            templateId: ds.selection.slide.get("template_id"), isLibrary: false, onCopySlide: slideId => {
                console.log(slideId);
                AddSlideController.replaceSlideInPresentation(slideId, ds.selection.slide);
            }
        });
    },

    addSlide: function() {
        checkSlideCount(ds.presentations, 1, ds.selection.presentation.getWorkspaceId()).then(() => {
            ShowDialog(AddSlideContainer);
        }).catch(err => {
            ErrorHandler.handleSlideLimitReached(err, { workspaceId: ds.selection.presentation.getWorkspaceId() });
        });
    },

    duplicateSlide: function() {
        app.mainView.editorView.duplicateSlide(ds.selection.slide);
    },

    deleteSlide: function() {
        app.mainView.editorView.deleteSlide(ds.selection.slide);
    },

    toggleMoreOptions: function(event) {
        event.stopPropagation();

        controls._createMenu(this.$moreOptions, getSlideMenu(), null,
            null,
            null,
            () => {
                this.$el.removeClass("active");
            });
    },

});

export { SlideOptions };
